import { Fragment } from "react";

function InputField(props) {
  const {
    id,
    ref,
    label,
    placeholder,
    defaultValue,
    value,
    register,
    error,
    type,
    disabled,
    className,
    size,
    style,
    icon,
    inputType,
    defaultChecked,
    onChange
  } = props;

  const smallHeight = size === 'small' ? { height: '30px' } : {}

  return (
    <Fragment>
      {label &&
        <label className="form-label">{label}</label>
      }
      <div className="form-addons">
        {inputType === 'textarea' ? (
          <textarea
            disabled={disabled}
            className={`form-control ${error ? 'is-invalid' : ''} ${className}`}
            style={{ ...style, ...smallHeight }}
            placeholder={placeholder}
            defaultValue={defaultValue}
            value={value}
            onChange={(e) => onChange(e)}
            {...register}
          />
        ) : (
          <Fragment>
            <input
              id={id}
              ref={ref}
              type={type}
              disabled={disabled}
              className={`form-control ${error ? 'is-invalid' : ''} ${className}`}
              style={{ ...style, ...smallHeight }}
              placeholder={placeholder || label}
              defaultChecked={defaultChecked}
              defaultValue={defaultValue}
              value={value}
              onChange={(e) => onChange(e)}
              {...register}
            />
            {type === 'checkbox' &&
              <label htmlFor={id} className="checktoggle" />
            }
          </Fragment>
        )}
        {icon &&
          icon
        }
        <div className="invalid-feedback">{error}</div>
      </div>
    </Fragment>
  );
}

export default InputField;
